/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: partner-delivery-endpoints-editor-component.ts
 *
 * Created by randysorensen on 5/9/17.
 */

'use strict';

function PartnerDeliveryEndpointsEditorController(
    this: JS5Object,
    _: JS5Object,
    $timeout: JS5Function,
    $routeParams: JS5Object,
    $route: JS5Object,
    $location: JS5Object,
    BreadcrumbService: JS5Object,
    PartnerEditService: JS5Object,
    UtilsService: JS5Object
) {
    const requiredFieldsLookup: JS5Object = {
        general: ['name'],
        applenews: ['channelId', 'apiKeyId', 'apiKeySecret'],
        aspera: ['serverAddress', 'userName'],
        aspera_cli: ['serverAddress', 'userName'],
        aspera_key: ['serverAddress', 'userName'],
        ftp: ['serverAddress'],
        itunes: ['networkPath', 'userName', 'password', 'logLevel'],
        ivi: ['iviUserName', 'iviPassword', 'iviNetworkId'],
        netflix: ['serverAddress', 'userName', 'netflixSSHKeyFilename', 'netflixClientId', 'netflixClientSecret', 'netflixPassword'],
        network: ['networkPath'],
        s3: ['s3Bucket', 'awsAccessKey', 'awsSecretKey'],
        sftp: ['serverAddress', 'userName'],
        uplynk: ['userName'],
        vantage: ['vantageWorkflow']
    };

    this.asperaTransferPolicies = [
        {
            label: 'Fixed - Transfer at the specified target rate',
            value: '-'
        },
        {
            label: 'Adaptive (Recommended) - Adjust and share network',
            value: '-Q'
        },
        {
            label: 'Low (Trickle)',
            value: '-QQ'
        },
    ];

    this.asperaResumePolicies = [
        {
            label: 'Off',
            value: '0'
        },
        {
            label: 'File attribute check',
            value: '1'
        },
        {
            label: 'Fast integrity check',
            value: '2'
        },
        {
            label: 'Full integrity check',
            value: '3'
        },
    ];

    this.asperaCLIRatePolicies = [
        {
            label: 'Fixed',
            value: 'fixed'
        },
        {
            label: 'High',
            value: 'high'
        },
        {
            label: 'Fair',
            value: 'fair'
        },
        {
            label: 'Low',
            value: 'low'
        }
    ];

    this.asperaCLICiphers = [
        {
            label: 'None',
            value: 'none'
        },
        {
            label: 'AES-128',
            value: 'aes-128'
        }
    ];

    this.iTunesDeliveryMethods = [
        {
            label: 'Auto (default)',
            value: 'Auto'
        },
        {
            label: 'Aspera',
            value: 'Aspera'
        },
        {
            label: 'Signiant',
            value: 'Signiant'
        },
        {
            label: 'DAV',
            value: 'DAV'
        }
    ];

    this.iTunesLogLevels = [
        {
            label: 'Off',
            value: 'off'
        },
        {
            label: 'Detailed',
            value: 'detailed'
        },
        {
            label: 'Informational',
            value: 'informational'
        },
        {
            label: 'Critical',
            value: 'critical'
        },
        {
            label: 'Extreme',
            value: 'eXtreme'
        }
    ];

    const getViewPermissions = () => {
        return PartnerEditService.getViewPermissions(PartnerEditService.viewStates.SYSTEM_PARTNERS_DELIVERYENDPOINTS_VIEW_STATE);
    };

    this.canWrite = false;

    const assignEndpointObject = (endpointObject: JS5Object) => {
        // UI shows kbps, not bps
        endpointObject.bandwidthThreshold = _.toNumber(endpointObject.bandwidthThreshold) / 1000;
        this.endpointObject = endpointObject;
    };

    const getEndpointEditData = () => {
        this.loadingIndicator.show = true;
        return PartnerEditService.getPartnerDeliveryEndpointEditData()
            .then((data: JS5Object) => {
                this.partnerObject = data.partnerObject;
                assignEndpointObject(data.endpointObject);

                this.partnerBreadcrumb.location = `/system/partners/edit/${this.partnerObject.id}/deliveryEndpoints`;
                this.partnerBreadcrumb.name = this.partnerObject.name;
                this.mediaConversionTemplates = data.mediaConversionTemplates;

                if (!!this.endpointObject.name) {
                    this.breadcrumbName = this.endpointObject.name;
                }

                PartnerEditService.parentRoute = `/system/partners/edit/${data.partnerObject.id}/deliveryEndpoints`;

                // loading indicator won't shut off without
                // wrapping this in a $timeout() ...?
                $timeout(() => {
                    this.loadingIndicator.show = false;
                });
            });
    };

    this.getEndpointTypeLabel = PartnerEditService.getEndpointTypeLabel;

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        this.endpointWorkflowTypeWhitelist = ['Vantage'];

        // Get endpoint protocol type from route param
        this.endpointType = $routeParams.endpointType;

        // Init partner breadcrumb
        BreadcrumbService.editService = PartnerEditService;

        this.partnerBreadcrumb = {
            location: '',
            name: '...',
            params: null
        };

        if (BreadcrumbService.getBreadcrumbs().length < 2) {
            // Why this "if" is necessary:
            //
            // When new endpoints are saved, the route params are
            // updated, reinstantiating this controller. This
            // causes redundant breadcrumbs to appear.
            BreadcrumbService.addBreadcrumb(this.partnerBreadcrumb);
        }

        // Init delivery endpoint breadcrumb
        this.breadcrumbName = 'New Delivery Endpoint';

        // Get endpoint & partner data
        getViewPermissions().then((permissions: JS5Object) => {
            this.canWrite = permissions.deliveryEndpointsWrite;
            getEndpointEditData();
        });
    };

    this.$postLink = () => {
        $timeout(() => {
            PartnerEditService.editorForm = this.editorForm;
        });
    };

    const saveEditData = () => {
        this.loadingIndicator.show = true;

        let endpointObject = _.cloneDeep(this.endpointObject);
        endpointObject.bandwidthThreshold = _.toNumber(this.endpointObject.bandwidthThreshold) * 1000;

        PartnerEditService
            .savePartnerDeliveryEndpoint(endpointObject)
            .then(() => {
                this.bradcrumbName = this.endpointObject.name;
                // UI shows kbps, not bps
                assignEndpointObject(PartnerEditService.endpointObject);
                this.loadingIndicator.show = false;
                $route.updateParams({endpointId: this.endpointObject.id});
            });
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => {
                const requiredFields = requiredFieldsLookup.general.concat(requiredFieldsLookup[this.endpointType]);
                let requiredFieldsArePopulated =
                    this.endpointObject && requiredFields.reduce((accum: boolean, field: string) => {
                        return accum && UtilsService.hasData(this.endpointObject[field]);
                    }, true);

                // special case for GDPR private key filename -
                // only required if GDPR enabled flag is set
                if (requiredFieldsArePopulated && _.get(this, 'endpointObject.generalDataProtectionRegulationFlag')) {
                    requiredFieldsArePopulated = _.size(this.endpointObject.privateKeyFilename) > 0;
                }

                // For UpLynk deliveries, require an API key, and
                // if there's a secondary username, require a
                // secondary API key
                if (requiredFieldsArePopulated && this.endpointType === 'uplynk'){
                    let hasApiKey = _.size(this.endpointObject.apiKey) > 0;
                    let hasSecondaryUsername = _.size(this.endpointObject.secondaryUserName) > 0;
                    let hasSecondaryApiKey = _.size(this.endpointObject.secondaryApiKey) > 0;

                    requiredFieldsArePopulated = (
                        hasApiKey &&
                        ((hasSecondaryUsername && hasSecondaryApiKey) ||
                         !hasSecondaryUsername)
                    );
                }

                const isNotPristine = this.editorForm && !this.editorForm.$pristine;

                return requiredFieldsArePopulated && isNotPristine;
            },
            onClick: saveEditData
        },
        {
            label: 'Revert',
            enabled: () => {
                const isNew = $routeParams.endpointId < 0;
                const isNotPristine = this.editorForm && !this.editorForm.$pristine;

                return isNew || isNotPristine;
            },
            onClick: () => {
                PartnerEditService.revertPartnerDeliveryEndpoint();
                assignEndpointObject(PartnerEditService.endpointObject);
            }
        },
        {
            label: 'Close',
            enabled: () => {
                return true;
            },
            onClick: PartnerEditService.exitEdit
        }
    ];

    this.onStepperChanged = (object: JS5Object, prop: JS5Object, min: JS5Object, max: JS5Object) => {
        UtilsService.clampNumericProp(object, prop, min, max);
    };

    this.numericFieldKeyDown = ($event: JS5Object, currentValue: string) => {
        if ($event.key.length === 1) {
            let newValue = currentValue || '';
            newValue += $event.key;
            if (!(/^[0-9]+$/.test(newValue))) {
                $event.preventDefault();
            }
        }
    };

}

angular.module('prism-ui.partner').component('partnerDeliveryEndpointsEditor', {
    templateUrl: 'system/partner/editor/components/view/deliveryEndpoints/editor/partner-delivery-endpoints-editor-template.html',
    controller: PartnerDeliveryEndpointsEditorController,
    bindings: {}
});
